import React from "react";
import {
    VirtualTable,
    TableFixedColumns,
    TableHeaderRow,
    TableBandHeader
} from "@devexpress/dx-react-grid-bootstrap4";
import classes from '../AnnualRemuneration.module.css'
import { Cell } from "./ARGridCellExtentions";

const processHeaderProps = (props) => {
    const {column, tableColumn, className, style} = props;

    let classN = `${className} ${classes.grid_cell_height} ${classes.headerCellFont}`;
    const cellStyle = tableColumn && tableColumn.column && tableColumn.column.style && tableColumn.column.style.header || {};
    const title = column && column.title;
    let icon = null;

    if (column && column.name === 'SignFoundDelta_App') {
        //icon = <div className={classes.attentionIcon} /> ;
    }

    const titleEl = (title || icon) && (
        <span className={`dx-rg-bs4-table-header-title m-auto ${!title && 'd-flex justify-content-center w-100'}`} title={title || ''}>
            {!!title && title.split('\n').map((value, index) => <React.Fragment key={new Date().getTime() + index}>{index > 0 ? <br/> : null}{value}</React.Fragment>)}
            {!!icon && icon}
        </span>
    ) || props.children || null;

    return {style: {...style, ...cellStyle, fontSize: props.fontSize}, className: classN, titleEl};
}

const processGridRowStyle = (row) => {
    const gridRowStyle = row?.GridRowStyle || 0;
    let style = {};
    switch (gridRowStyle) {
        case "7":
            style = {color: "#1cc11c", fontWeight: "bold"}
            break;
        case "8":
            style = {fontWeight: "bold"}
            break;
        case "22":
            style = { color: "gray"}
            break;

    }

    return style;
}

const processProps = (props) => {
    const tableColumn = props.tableColumn;
    let className = props.className || '';
    const rootRowStyle = props?.row?.treeInfo?.Level === 1 ? {borderTop: "2px solid #ccc"} : {};
    const style = {...props.style, ...rootRowStyle, fontSize: props.fontSize};
    const cellStyle = tableColumn && tableColumn.column && tableColumn.column.style && tableColumn.column.style.cell || {};
    const greedRowStyle = processGridRowStyle(props?.row);

    if (props.tableColumn && props.tableColumn.column) {
        className = className +  ' ' + (props.tableColumn.column.cellClassName || '') + ' ' + classes.grid_cell_height;
        className = className.replace('border-right', '');
    }

    return {className, style: {...style, ...cellStyle, ...greedRowStyle}};
}

export const VirtualCell = (props) => {
    const processedProps = processProps(props);
    return <VirtualTable.Cell {...props} {...processedProps}/>
}

export const FixedCell = (props) => {
    const processedProps = processProps(props);
    return <TableFixedColumns.Cell {...props} {...processedProps} />
}

export const HeaderCell = (props) => {
    let {className, style, titleEl} = processHeaderProps(props);
    return (
      <TableHeaderRow.Cell {...props} className={className} style={style}>
          { titleEl }
      </TableHeaderRow.Cell>
    )
}


const levelToExpand = 1
export const FilterCellContent = ({ firstRow: row = {}, rowTreeInfo, columnStyles, style, toggleExpand, ...props }) => {
    let {className} = processHeaderProps(props);
    const column = props.column;
    let columnStyle = column?.style?.cell || {};
    style = {...style, fontWeight: "bold", fontSize: props.fontSize, ...columnStyle};
    className = `${className} ${!!columnStyles.align && ("text-"+columnStyles.textAlign) || "text-right"}`

    const { IsEmpty } = row.treeInfo

    const treeInfo = [];
    let isExpanded = false;
    for (let i in rowTreeInfo) {
        const item = rowTreeInfo[i];
        if (item.Level === levelToExpand) {
            treeInfo.push({...item, RowIndex: i});
            isExpanded |= item.IsExpanded;
        }
    }

    const toggle = async () => {
        await toggleExpand(levelToExpand, isExpanded);
    }

    const iconClass = IsEmpty ? '' : `zmdi zmdi-${isExpanded ? "minus" : "plus"}-square`;

    return (
      <TableHeaderRow.Cell {...props} className={className} style={style}>
          {column.name === "OrgStructInfo" &&
            <div style={{paddingLeft: "25px", display: "flex", alignItems: "center"}}>
                <i className={iconClass}
                   style={{margin: `0 5px 0 0`, cursor: "pointer"}} onClick={toggle}></i>
                <Cell column={column} row={row} value={row[column.name]} />
            </div>
          }
          {column.name !== "OrgStructInfo" &&
            <Cell column={column} row={row} value={row[column.name]} />
          }
      </TableHeaderRow.Cell>
    )
}

export const BandCell = (props) => {
    let {className, style, titleEl} = processHeaderProps(props);

    return (
        <TableBandHeader.Cell {...props} style={style} className={className}>
            { titleEl }
        </TableBandHeader.Cell>
    );
};